module.exports = __webpack_public_path__ + "static/media/image-opinion-campaign-donate-1.644c56bc.png";